// START_MODULE theme_theme_ts
// START_CONTRACT
// PURPOSE: Preserve this module from the original Tomsk Data Science frontend.
// OPERATIONAL_CONTEXT: Imported by the public static React application.
// CONTRACT: Keep the established layout, styling, and component behavior intact.
// KEYWORDS: legacy-frontend, static-site, tomsk-data-science
// COMPLEXITY: 2
// END_CONTRACT
import { DefaultTheme } from 'styled-components';

export const theme: DefaultTheme = {
  accentColor: '#0058DE',
  accentFontFamily: 'Beba Bold, sans-serif',

  softAccentColor: '#93B1DE',
  darkAccentColor: '#003fa3',
  extraDarkAccentColor: '#002763',
};

// END_MODULE theme_theme_ts
